import { render, staticRenderFns } from "./taskList.vue?vue&type=template&id=2bcc3c51&scoped=true&"
import script from "./taskList.vue?vue&type=script&lang=js&"
export * from "./taskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcc3c51",
  null
  
)

export default component.exports